module.exports = __webpack_public_path__ + "img/vector2.e80bd463.svg";